exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--file__18cNS{display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer}.styles--icon__1X9RC{height:21px;border-radius:4px}.styles--filename__DZTGP{margin-left:5px}\n", ""]);

// exports
exports.locals = {
	"file": "styles--file__18cNS",
	"icon": "styles--icon__1X9RC",
	"filename": "styles--filename__DZTGP"
};